import React from "react";
import { useContext, useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";
import { LoginFormContext } from "context/LoginFormContext";
import { getAboutUsById } from "Apis/aboutUs";
import user from "../../assets/images/user.png";
import colors from "assets/theme/base/colors";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller;
  const location = useLocation();
  const collapseName = location.pathname.replace("/", "");
  const { modules, setProfileName, profile, setProfile } = useContext(LoginFormContext);
  const [allRoutes, setAllRoutes] = useState([]);
  const [token, setToken] = useState(null);
  const [openKey, setOpenKey] = useState(null);
  const { sideNav } = colors;
  let textColor = "dark";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }

    window.addEventListener("resize", handleMiniSidenav);

    handleMiniSidenav();

    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Function to check read permission for all the modules.
  const getSidebarRoutes = () => {
    let myRoutes = [];
    let parent = [];
    routes.forEach((route) => {
      if (route?.noCollapse) {
        let moduleAccess = modules.find((module) => module.name === route?.moduleName);
        if (moduleAccess) {
          if (moduleAccess.permissions.read_access) {
            parent.push(route);
          }
        } else {
          if (route?.name === "Dashboard") {
            parent.push(route);
          } else {
            parent.push(route);
          }
        }

        if (route?.accessPermission) {
          parent.push(route);
        }
      }

      let collapse = [];
      route?.collapse?.forEach((child) => {
        /* CHECK MODULE ACCESS FOR EACH */
        let moduleAccess = modules.find((module) => module.name === child.moduleName);
        if (moduleAccess) {
          if (moduleAccess.permissions.read_access) {
            collapse.push(child);
          }
        } else {
          if (child.name === "Dashboard") {
            collapse.push(child);
          } else {
            collapse.push(child);
          }
        }

        if (child.accessPermission) {
          collapse.push(child);
        }

        let subCollapse = [];
        child?.collapse?.forEach((subChild) => {
          /* CHECK MODULE ACCESS FOR EACH */
          let moduleAccess = modules.find((module) => module.name === subChild.moduleName);
          if (moduleAccess) {
            if (moduleAccess.permissions.read_access) {
              subCollapse.push(subChild);
            }
          } else {
            if (subChild.name === "Dashboard") {
              subCollapse.push(subChild);
            } else {
              subCollapse.push(subChild);
            }
          }

          if (subChild.accessPermission) {
            subCollapse.push(subChild);
          }
        });
        if (child?.collapse?.length > 0) {
          child.collapse = subCollapse;
        }
      });

      let activeRoute = route?.collapse?.filter((childRoute) => {
        return childRoute.route === location.pathname;
      });

      // PARENT ONLY HAS ACCESS IF ANY CHILD HAS
      if (collapse.length > 0) {
        myRoutes.push({ isOpen: activeRoute.length > 0, ...route, collapse });
      }
    });

    // PARENT ONLY HAS ACCESS IF ANY CHILD HAS
    if (parent.length > 0) {
      myRoutes.push(...parent);
    }
    let sortArray = [];
    routes.map((array) => {
      let findArray = myRoutes.map((e) => e.key).indexOf(array.key);
      if (findArray >= 0) {
        sortArray.push(myRoutes[findArray]);
      }
    });
    setAllRoutes(sortArray);
  };

  useEffect(() => {
    getSidebarRoutes();
  }, [modules]);

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  // const renderRoutes = allRoutes.map(
  //   ({ type, name, icon, title, noCollapse, key, href, route }) => {
  //     let returnValue;

  //     if (type === "collapse") {
  //       returnValue = href ? (
  //         <Link
  //           href={href}
  //           key={key}
  //           target="_blank"
  //           rel="noreferrer"
  //           sx={{ textDecoration: "none" }}
  //         >
  //           <SidenavCollapse
  //             name={name}
  //             icon={icon}
  //             active={key === collapseName}
  //             noCollapse={noCollapse}
  //           />
  //         </Link>
  //       ) : (
  //         <NavLink key={key} to={route}>
  //           <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
  //         </NavLink>
  //       );
  //     } else if (type === "title") {
  //       returnValue = (
  //         <MDTypography
  //           key={key}
  //           color={textColor}
  //           display="block"
  //           variant="caption"
  //           fontWeight="bold"
  //           textTransform="uppercase"
  //           pl={3}
  //           mt={2}
  //           mb={1}
  //           ml={1}
  //         >
  //           {title}
  //         </MDTypography>
  //       );
  //     } else if (type === "divider") {
  //       returnValue = (
  //         <Divider
  //           key={key}
  //           light={
  //             (!darkMode && !whiteSidenav && !transparentSidenav) ||
  //             (darkMode && !transparentSidenav && whiteSidenav)
  //           }
  //         />
  //       );
  //     }

  //     return returnValue;
  //   }
  // );

  const handleParentToggle = (key, hasChildren) => {
    if (!hasChildren) {
      setOpenKey(null);
    } else {
      setOpenKey((prev) => (prev === key ? null : key));
    }
  };

  const renderRoutes = (routes) =>
    routes.map(({ type, name, icon, title, key, route, collapse }) => {
      if (type === "collapse") {
        if (collapse && collapse.length > 0) {
          const isChildActive = collapse.some((c) => c.route === location.pathname);
          const isOpen = openKey === key || isChildActive;
          return (
            <SidenavCollapse
              key={key}
              name={name}
              icon={icon}
              active={false}
              isOpen={openKey === key || isChildActive}
              onToggle={() => handleParentToggle(key, !!collapse?.length)}
            >
              {renderRoutes(collapse)}
            </SidenavCollapse>
          );
        }
        return (
          <NavLink
            key={key}
            to={route}
            style={{ textDecoration: "none" }}
            onClick={() => handleParentToggle(key, false)}
          >
            <SidenavCollapse name={name} icon={icon} active={route === location.pathname} />
          </NavLink>
        );
      }

      if (type === "title") {
        return (
          <MDTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MDTypography>
        );
      }

      if (type === "divider") {
        return (
          <Divider
            key={key}
            light={
              (!darkMode && !whiteSidenav && !transparentSidenav) ||
              (darkMode && !transparentSidenav && whiteSidenav)
            }
          />
        );
      }

      return null;
    });

  useEffect(() => {
    let data = localStorage.getItem("authorization");
    setToken(data);
  }, []);

  const getProfileImage = async () => {
    let response = await getAboutUsById();
    const data = response?.data?.data?.result;
    setProfile({
      url: data?.information_images?.[0]?.image || "",
      name: null,
    });
    setProfileName(data?.name);
  };

  useEffect(() => {
    getProfileImage();
  }, []);

  return (
    <>
      <SidenavRoot
        {...rest}
        variant="permanent"
        ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
        sx={{ padding: "0 !important" }}
      >
        <MDBox pt={2} pb={0} px={2} textAlign="center">
          <MDBox
            display={{ xs: "block", xl: "none" }}
            position="absolute"
            top={0}
            right={0}
            p={1.625}
            onClick={closeSidenav}
            sx={{ cursor: "pointer" }}
          >
            <MDTypography variant="h6" color="secondary">
              <Icon sx={{ fontWeight: "bold" }}>close</Icon>
            </MDTypography>
          </MDBox>
          <MDBox
            component={NavLink}
            to="/dashboard"
            display="flex"
            flexDirection="column"
            alignItems="center"
            width="100%"
          >
            {profile && (
              <MDBox
                component="img"
                src={profile?.url === null ? user : profile?.url}
                alt="Brand"
                width="75px"
                height="75px"
                sx={{
                  gap: "4px",
                  borderRadius: "100%",
                  boxShadow: `${sideNav.boxShadow}`,
                }}
              />
            )}
            <MDBox sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}>
              <MDBox
                fontWeight="medium"
                color={sideNav.textColor}
                sx={{ textWrap: "wrap", marginTop: "15px", fontSize: "18px" }}
              >
                {brandName}
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
        {/* <Divider
          fullWidth
          sx={{ borderColor: "drakgray !important" }}
          // light={
          //   (!darkMode && !whiteSidenav && !transparentSidenav) ||
          //   (darkMode && !transparentSidenav && whiteSidenav)
          // }
        /> */}
        <Divider component={"div"} sx={{ opacity: "0.9 !important" }} />

        <List sx={{ color: `${sideNav.textColor} !important` }}>{renderRoutes(allRoutes)}</List>

        {/* <Divider component={"div"} sx={{ opacity: "0.9 !important" }} />
        <List sx={{ color: `${sideNav.textColor} !important` }}>{renderRoutes}</List> */}
      </SidenavRoot>
    </>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
